








































import {Component, Vue} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import DlgAdNew from '../../../modules/ads/_components/DlgAdNew.vue';
import DlgAdDelete from '../../../modules/ads/_components/DlgAdDelete.vue';
import DlgAdEdit from '../../../modules/ads/_components/DlgAdEdit.vue';
import Card from '../../../components/material/Card.vue';

@Component({
  components: {
    DlgAdNew,
    DlgAdDelete,
    DlgAdEdit,
    Card,
  },
})
export default class AdsList extends Vue {
  @Getter('ads/all') private ads!: any[];
  @Action('ads/read') private readAll!: any;
  private loading: boolean = false;

  private headers: any[] = [
    {
      text: 'Titel',
      align: 'left',
      value: 'title',
    },
    {
      text: 'Gültig Von',
      align: 'left',
      value: 'validFromParsed',
    },
    {
      text: 'Gültig Bis',
      align: 'left',
      value: 'validToParsed',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  private search: string = '';

  private created() {
    this.loading = true;
    this.readAll()
      .then(() => {
        this.loading = false;
      });
  }
}
